import {useState, useContext, useEffect, createContext} from 'react';
import {useHistory, useRouteMatch} from 'react-router';
import PendingPaymentModal from 'modules/membership/plans/PendingPaymentModal';
import {useMembership} from './MembershipContext';
import {isEmpty} from 'lodash';

const PendingPaymenFeatureContext = createContext();

function PendingPaymenFeatureProvider(props) {
  const {children} = props;
  const {isPendingPayment} = useMembership();
  const history = useHistory();
  const isContactUs = useRouteMatch('/contact');

  const [isOpen, setIsOpen] = useState(false);
  const [goDashboard, setGoDashboard] = useState(false);

  useEffect(() => {
    if (!isEmpty(isContactUs) && isOpen) setIsOpen(false);
  }, [isContactUs, isOpen]);

  function toggleOpen(goBack = false) {
    if (isPendingPayment) {
      setIsOpen(true);
      setGoDashboard(goBack);
    }
  }

  function toggleClose() {
    setIsOpen(false);

    if (goDashboard) {
      // reset go back feature
      setGoDashboard(false);
      history.push('/dashboard');
    }
  }

  return (
    <PendingPaymenFeatureContext.Provider
      value={{togglePendingPayment: toggleOpen}}
    >
      {children}

      <PendingPaymentModal toggleClose={toggleClose} isOpen={isOpen} />
    </PendingPaymenFeatureContext.Provider>
  );
}

const usePendingPaymentFeature = () => useContext(PendingPaymenFeatureContext);

export {
  PendingPaymenFeatureContext,
  PendingPaymenFeatureProvider,
  usePendingPaymentFeature,
};
